import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.4.106c-.3-.195-.8-.098-1.1.098l-9 6.843c-.2.196-.3.49-.3.782s.1.587.4.782l9 6.843c.2.098.4.196.6.196.1 0 .3 0 .4-.098.3-.196.6-.489.6-.88V.986q0-.585-.6-.88M9 12.717 2.6 7.83 9 2.941zM21.4.107c-.3-.196-.8-.099-1.1.097l-9 6.843c-.2.196-.3.49-.3.782s.1.587.4.782l9 6.843c.2.098.4.196.6.196.1 0 .3 0 .4-.098.3-.196.6-.489.6-.88V.986q0-.585-.6-.879M20 12.717l-6.4-4.889L20 2.941z"
    }, null, -1)
  ]))]))
}
export default { render: render }